export { SmartImage } from './smart-image'
